import Vue from "vue";
import App from "./App";
import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
import Axios from "axios";
import Moment from "moment";
import router from "./router";
import Push from "push.js";

// Axios请求的统一配置
// Axios.defaults.baseURL = 'http://jgdesktop.test.jgyljt.com' // 作废
// Axios.defaults.baseURL = "http://desktop-test.api.jgyljt.com";
Axios.defaults.baseURL = "https://desktop.api.jgyljt.com";

// 拦截器
Axios.interceptors.request.use(
  config => {
    config.headers["Content-Type"] =
      "application/x-www-form-urlencoded;charset=UTF-8";
    // config.headers['dataType'] = 'jsonp'
    const token = localStorage.getItem("token");
    if (token) {
      config.headers["Authorization"] = token; // 让每个请求携带自定义 token 请根据实际情况自行修改
    }
    return config;
  },
  err => {
    return Promise.reject(err);
  }
);
Axios.interceptors.response.use(
  response => {
    return response;
  },
  error => {
    if (error.response) {
      switch (error.response.status) {
        case 401:
          // 返回 401 清除token信息并跳转到登录页面
          localStorage.removeItem("token");
          localStorage.removeItem("name");
          localStorage.removeItem("expires_in");
          localStorage.removeItem("dingdingImg");
          localStorage.removeItem("dingdingUserId");
          localStorage.removeItem("union_id");
          localStorage.removeItem("pro__Access-Token");
          router.push({ path: "/login" });
      }
    }
    return Promise.reject(error.response.data); // 返回接口返回的错误信息
  }
);
Axios.defaults.transformRequest = [
  data => {
    let ret = "";
    for (let it in data) {
      ret += encodeURIComponent(it) + "=" + encodeURIComponent(data[it]) + "&";
    }
    return ret;
  }
];
Vue.config.productionTip = false; //阻止vue启动时生成错误
Vue.prototype.$http = Axios;
Vue.prototype.baseUrl = Axios.defaults.baseURL;
Vue.use(ElementUI);
Vue.use(Moment);
Vue.use(Push);
router.beforeEach((to, from, next) => {
  const tokenCheck = localStorage.getItem("token");
  if (tokenCheck) {
    if (to.path === "/login") {
      next({ path: "/" });
    } else {
      next();
    }
  } else {
    if (to.path !== "/login") {
      next({ path: "/login" });
    } else {
      next();
    }
  }
});
/* eslint-disable no-new */
new Vue({
  el: "#app",
  router,
  components: { App },
  template: "<App/>"
});
Vue.config.productionTip = false;



// WEBPACK FOOTER //
// ./src/main.js